export const CommonSettingBase = '/common-setting';
